/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plus_Q3_TitleInputs */

const en_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunlit Recharge`)
};

const ar_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة الشحن تحت أشعة الشمس`)
};

const de_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufladen im Sonnenlicht`)
};

const es_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarga bajo la luz del sol`)
};

const fr_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recharge solaire`)
};

const it_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricarica Solare`)
};

const ja_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`陽だまりのひととき`)
};

const ko_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`햇빛 재충전`)
};

const pt_br_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregamento ao Sol`)
};

const ru_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Солнечная подзарядка`)
};

const th_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชาร์จพลังในแสงแดด`)
};

const tr_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güneş Işığında Şarj`)
};

const zh_cn_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向阳充能季`)
};

const zh_tw_plus_q3_title = /** @type {(inputs: Plus_Q3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向陽充能季`)
};

/**
* | output |
* | --- |
* | "Sunlit Recharge" |
*
* @param {Plus_Q3_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plus_q3_title = /** @type {((inputs?: Plus_Q3_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plus_Q3_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plus_q3_title(inputs)
	if (locale === "ar") return ar_plus_q3_title(inputs)
	if (locale === "de") return de_plus_q3_title(inputs)
	if (locale === "es") return es_plus_q3_title(inputs)
	if (locale === "fr") return fr_plus_q3_title(inputs)
	if (locale === "it") return it_plus_q3_title(inputs)
	if (locale === "ja") return ja_plus_q3_title(inputs)
	if (locale === "ko") return ko_plus_q3_title(inputs)
	if (locale === "pt_br") return pt_br_plus_q3_title(inputs)
	if (locale === "ru") return ru_plus_q3_title(inputs)
	if (locale === "th") return th_plus_q3_title(inputs)
	if (locale === "tr") return tr_plus_q3_title(inputs)
	if (locale === "zh_cn") return zh_cn_plus_q3_title(inputs)
	return zh_tw_plus_q3_title(inputs)
});